import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const deMenus = () => {
    const basePath = getDomainConfig(getLocale('de-DE').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
                alt: 'Raisin',
            },
        ],
        navItems: [],
        actionItems: [
            {
                id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
                title: 'Anmelden',
                href: `${basePath}/login/`,
                type: 'login',
            },
        ],
    };
};
//# sourceMappingURL=deMenus.js.map